import { useQuery } from '@tanstack/react-query';

import { getCartPrice } from '../../api/bookings';

export function useCartPriceInfoQuery(campId: number, childIds: number[]) {
  const prices = usePriceQuery(campId, childIds);
  const cartPricingInfo = prices.data?.ok ? prices.data?.body : null;
  const totalPrice = Number(cartPricingInfo?.total);
  return {
    cartPricingInfo,
    totalPrice,
  };
}

function usePriceQuery(campId: number, childIds: number[]) {
  return useQuery({
    queryKey: ['price', campId, childIds],
    queryFn: () => getCartPrice('camp', undefined, childIds, campId),
  });
}
